/**
 * FavoritesView (NEW) - plays back the user's saved videos using the same
 * <Feed> engine, but ad-free and untracked. Videos are reconstructed from the
 * self-contained favorite snapshots (resolved playlist/poster/avatar URLs).
 */
import { useState, useEffect } from 'preact/hooks';
import { Feed } from './Feed.jsx';

const EMPTY_FEED = { cdnUrl: '', cdnPath: '', imageBase: '' };

export function FavoritesView({ favorites, showChat, onRequestChat, onReachEnd }) {
  const [videos, setVideos] = useState(() => [...favorites.favorites]);

  // Rebuild when the set of saved videos changes (e.g. user un-saves one,
  // or the active channel scope switches).
  const idsKey = favorites.favorites.map((f) => f.id).join(',');
  useEffect(() => {
    setVideos([...favorites.favorites]);
  }, [idsKey]);

  return (
    <Feed
      videos={videos}
      setVideos={setVideos}
      feed={EMPTY_FEED}
      content="favorites"
      favorites={favorites}
      enableAds={false}
      enableTracking={false}
      showChat={showChat}
      onRequestChat={onRequestChat}
      showEndSlide
      onReachEnd={onReachEnd}
      emptyMessage="No favorites yet — tap ⭐ on a video to save it here"
    />
  );
}
